/* ===== Modul principal client — campanie · fidelizare · evenimente (toate temele) ===== */
import { syncConnectPromoRow, getConnectActiveModule } from './client-connect-template.js?v=83.58';
import { updateClientPrimaryActionSlots } from './loyalty-module.js?v=83.58';
import {
  isAlfaTemplateActive,
  isConnectTemplateActive,
  isCustomTemplateActive
} from './client-template-style.js?v=83.58';

export { getConnectActiveModule as getActivePrimaryModule };

/** Sincronizează slotul principal pe card promo (Connect/Alfa) + CTA (#playBtn) pe toate temele. */
export function syncPrimaryModuleClientUI(settings = {}) {
  const page = document.getElementById('clientPage');
  if (
    isConnectTemplateActive(page) ||
    isAlfaTemplateActive(page) ||
    isCustomTemplateActive(page)
  ) {
    syncConnectPromoRow(settings);
  }
  updateClientPrimaryActionSlots(settings);
}
